window.addEventListener(
  "load",
  function () {
    var countDownWrapperElement = document.getElementById("countdown-wrapper");
    if (countDownWrapperElement) {
      var countDownDate = new Date(countDownWrapperElement.dataset.countto);

      var groupOrderContentElement = document.getElementById("group-order-content");
      groupOrderContentElement.innerHTML = groupOrderContentElement.innerHTML.replace(
        /\[end_date\]/g,
        `${countDownDate.getDate()}-${countDownDate.getMonth() + 1}-${countDownDate.getFullYear()}`
      );
    }
    var shareLink = document.getElementById("group-order-share-link");
    if (shareLink) {
      var shareLinkElements = document.querySelectorAll("a[rel='group-order-share-link'], a[href='group-order-share-link']");

      shareLinkElements.forEach((shareLinkElement) => {
        shareLinkElement.setAttribute("href", shareLink.getAttribute("href"));
      });
    }
  },
  false
);

// Set the date we're counting down to
var countDownWrapperElement = document.getElementById("countdown-wrapper");
var countDownElement = document.getElementById("countdown");

if (countDownElement) {
  var countDownDate = new Date(countDownWrapperElement.dataset.countto).getTime();

  countDownWrapperElement.classList.add("loaded");

  var daysTensNumlistElement = document.querySelector(".days.tens > .numlist");
  var daysOnesNumlistElement = document.querySelector(".days.ones > .numlist");

  var hoursTensNumlistElement = document.querySelector(".hours.tens > .numlist");
  var hoursOnesNumlistElement = document.querySelector(".hours.ones > .numlist");

  var minutesTensNumlistElement = document.querySelector(".minutes.tens > .numlist");
  var minutesOnesNumlistElement = document.querySelector(".minutes.ones > .numlist");

  var secondsTensNumlistElement = document.querySelector(".seconds.tens > .numlist");
  var secondsOnesNumlistElement = document.querySelector(".seconds.ones > .numlist");

  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    var padDays = zeroPad(days, 2);
    var padHours = zeroPad(hours, 2);
    var padMinutes = zeroPad(minutes, 2);
    var padSeconds = zeroPad(seconds, 2);

    daysTensNumlistElement.className = "numlist dt-" + padDays.charAt(0);
    daysOnesNumlistElement.className = "numlist do-" + padDays.charAt(1);

    hoursTensNumlistElement.className = "numlist dt-" + padHours.charAt(0);
    hoursOnesNumlistElement.className = "numlist do-" + padHours.charAt(1);

    minutesTensNumlistElement.className = "numlist dt-" + padMinutes.charAt(0);
    minutesOnesNumlistElement.className = "numlist do-" + padMinutes.charAt(1);

    secondsTensNumlistElement.className = "numlist dt-" + padSeconds.charAt(0);
    secondsOnesNumlistElement.className = "numlist do-" + padSeconds.charAt(1);

    // Display the result in the element with id="demo"
    // document.getElementById("countdown").innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("countdown").innerHTML = "";
    }
  }, 1000);
  function zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }
}
